// extracted by mini-css-extract-plugin
export var root = "sYndo";
export var rootV9 = "SrfOa";